import {
  Button,
  Drawer,
  Input,
  Select,
  Form,
  Space,
  Spin,
  Tooltip,
  Divider,
} from "antd";
import LedgerService, {
  ILedgerAddResponse,
  LedgerStatus,
  SearchLedgerByGroupsTypes,
} from "../../Services/LedgerService";
import CostCentersServices, {
  ICostCentre,
  ICostCentresList,
} from "../../Services/CostCentersServices";
import { notificationContext } from "../../Common/Routing/PageRoute";
import React, { useState, useEffect, useContext } from "react";
import { useClient } from "../../Context/ClientContext";
import {
  CloseOutlined,
  LoadingOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { useHotkey } from "../../Context/HotKeyContext";
import EntryLevelKeys from "../../Common/EntryLevelKeys";
import AddLedger from "../Master/Ledger/AddLedger";
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

interface IAddCostCentreModelProps {
  // onCancel: (value: boolean) => void;
  isModalOpen: boolean;
  setPostCostCentreData?: React.Dispatch<
    React.SetStateAction<ICostCentresList>
  >;
  setIsModalOpen: React.Dispatch<
    React.SetStateAction<{
      open: boolean;
      id: string;
    }>
  >;
  id?: string;
  setRefresh?: React.Dispatch<React.SetStateAction<boolean>>;
  expenseId?: string;
}
interface IExpenseData {
  expenseId: string;
  ledgerName: string;
}

const AddCostCentreModel = (props: IAddCostCentreModelProps) => {
  console.log(props);
  const { showKeys } = useHotkey();
  const { openNotification } = useContext(notificationContext);
  const [loading, setLoading] = useState<boolean>(false);
  const [dataLoading, setDataLoading] = useState<boolean>(false);
  const [form] = Form.useForm<ICostCentre>();
  const [costCentreAvailable, setCostCentreAvailable] =
    useState<boolean>(false);
  const [expenseData, setExpenseData] = React.useState<IExpenseData[]>([]);
  const [addLedgerResponse, setAddLedgerResponse] =
    useState<ILedgerAddResponse | null>(null);
  const [costCentresList, setCostCentresList] = React.useState<
    ICostCentresList[]
  >([]);
  const [openModel, setOpenModel] = useState<{
    type: string;
    param: { open: boolean };
  }>({
    type: "",
    param: { open: false },
  });
  const { currentClient } = useClient();

  // To get all expenses ledgers
  const getAllLedgers = async () => {
    await LedgerService.getLedgersByGroupName(
      currentClient?.id!,
      SearchLedgerByGroupsTypes.AllExpenses
    )
      .then((res) => {
        if (res!) {
          const filteredExpenseData: IExpenseData[] = res.map<IExpenseData>(
            (each) => ({
              expenseId: each.id,
              ledgerName: each.ledgerName,
            })
          );
          setExpenseData(filteredExpenseData!);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getCostCentresList = async () => {
    await CostCentersServices.getCostCentersList(
      currentClient?.id!,
      0,
      0,
      "",
      "",
      "",
      "",
      LedgerStatus.all
    )
      .then((res) => {
        if (res.result?.items.length > 0) {
          setCostCentresList(res.result?.items);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    setLoading(true);
    Promise.all([getAllLedgers(), getCostCentresList()])
      .then(() => {
        setLoading(false);
      })
      .catch((e: any) => {
        setLoading(false);
        console.log("Error", e?.message);
      });
  }, [currentClient?.id]);

  const onClose = () => {
    form.resetFields();
    props.setIsModalOpen({
      open: false,
      id: "",
    });
  };

  //-----Adding new expense Ledger Data ---------
  useEffect(() => {
    if (addLedgerResponse?.id) {
      setExpenseData((pre: IExpenseData[]) => {
        let newData = [
          ...pre,
          {
            expenseId: addLedgerResponse.id,
            ledgerName: addLedgerResponse.ledgerName,
          },
        ];
        return newData;
      });
    }
  }, [addLedgerResponse]);

  //-------- setting new added ledger data in form ---------
  useEffect(() => {
    if (addLedgerResponse?.id) {
      form.setFieldValue("expenseId", addLedgerResponse.id);
    }
  }, [expenseData]);
  console.log("expenseData", expenseData);
  props?.expenseId &&
    expenseData.length > 0 &&
    form.setFieldValue("expenseId", props?.expenseId);
  // To get record from Get
  const getCostCentre = async () => {
    setDataLoading(true);
    return await CostCentersServices.getCostCentre(
      currentClient?.id!,
      props?.id!
    )
      .then((res) => {
        if (res) {
          form.setFieldsValue(res);
        }
        setDataLoading(false);
      })
      .catch((err) => {
        setDataLoading(false);
        console.log(err);
      });
  };
  useEffect(() => {
    if (props?.id) getCostCentre();
  }, [props?.id]);

  // To post the cost centre
  const postcost = async (postData: ICostCentre, id?: string) => {
    try {
      setLoading(true);
      await CostCentersServices.postCostCenter(currentClient?.id!, postData, id)
        .then((data) => {
          if (data.status) {
            props.setPostCostCentreData &&
              props.setPostCostCentreData({
                costCentreName: data?.result?.costCentreName,
                expenseId: data?.result?.expenseId,
                id: data?.result?.id,
                status: data?.result?.status,
              });
            props.setRefresh && props.setRefresh((prev) => !prev);
            props.setIsModalOpen({
              open: false,
              id: "",
            });
            setLoading(false);
            openNotification(
              "success",
              props.id ? "Updated successfully " : "Added successfully"
            );
          } else {
            setLoading(false);
            openNotification(
              "error",
              "There something wrong with getting data."
            );
          }
        })
        .catch((err) => {
          setLoading(false);
          openNotification("error", err?.message);
        });
      onClose();
    } catch (err: any) {
      setLoading(false);
      openNotification("error", err?.message);
    }
  };
  const checkDuplidateCostCentre = async (e: any) => {
    let ledDetail = costCentresList
      ?.filter((led) => led.id !== props.id)
      .filter(
        (led) =>
          led.costCentreName.toLowerCase() ===
          e?.target?.value.trim().toLowerCase()
      );
    setCostCentreAvailable(ledDetail?.length! > 0 ? true : false);
  };

  EntryLevelKeys({
    save: () => {
      form.validateFields().then((data: ICostCentre) => {
        postcost(data, props.id);
      });
    },
    cancel: () => onClose(),
  });

  return (
    <>
      <Drawer
        open={props.isModalOpen}
        title={props.id ? "Update Cost Centre" : "Add Cost Centre"}
        width={"500px"}
        onClose={onClose}
        closable={false}
        extra={
          <Space>
            <CloseOutlined onClick={() => onClose()} />
          </Space>
        }
        maskClosable={false}
        footer={
          <div style={{ textAlign: "right" }}>
            <Space>
              <Tooltip
                title={<p>ALT+S</p>}
                placement="topLeft"
                open={showKeys}
                style={{}}
              >
                <Button
                  type="primary"
                  disabled={loading}
                  onClick={() => {
                    form.validateFields().then((data: ICostCentre) => {
                      postcost(data, props.id);
                    });
                  }}
                >
                  {props?.id ? "Update" : "Save"}
                </Button>
              </Tooltip>
              <Tooltip
                title={<p>ALT+C</p>}
                placement="topLeft"
                open={showKeys}
                style={{}}
              >
                <Button onClick={onClose}>Cancel</Button>
              </Tooltip>
            </Space>
          </div>
        }
      >
        <Spin spinning={loading || dataLoading} indicator={antIcon}>
          <Form form={form} layout="vertical" autoFocus>
            <Form.Item
              label="Cost Center Name"
              name="costCentreName"
              className="input-item"
              rules={[
                {
                  required: true,
                  pattern:
                    /^[A-Za-z][A-Za-z0-9_/()-]+(?:\s[A-Za-z0-9_/()-]+)*$/,
                  message:
                    "Cost centre name is required. Only alphanumeric characters with space, (, ), _, / and - are allowed",
                },
                {
                  min: 3,
                  max: 30,
                  message:
                    "Cost center name must be at least 3 characters minimum and 30 characters maximum",
                },
                {
                  validator: () => {
                    if (costCentreAvailable) {
                      return Promise.reject(
                        "Cost centre's name already exists."
                      );
                    } else {
                      return Promise.resolve();
                    }
                  },
                },
              ]}
            >
              <Input
                placeholder="Enter cost center name"
                onChange={checkDuplidateCostCentre}
              />
            </Form.Item>
            <Form.Item
              name="expenseId"
              label="Expense Ledger"
              rules={[
                { required: true, message: "Please select an expense ledger" },
              ]}
              className="input-item"
            >
              <Select
                placeholder="select Expense Ledger"
                allowClear
                showSearch
                disabled={props?.expenseId ? true : false}
                filterOption={(input, option) =>
                  (option?.label?.toString() ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={expenseData?.map((each: IExpenseData) => ({
                  key: each.expenseId,
                  title: "",
                  value: each.expenseId,
                  label: each.ledgerName,
                }))}
                dropdownRender={(expenseData) => (
                  <>
                    {expenseData}
                    <>
                      <Divider
                        style={{
                          margin: "5px 0px",
                        }}
                      />
                      <Button
                        style={{
                          width: "100%",
                        }}
                        icon={<PlusOutlined />}
                        onClick={() => {
                          setOpenModel({
                            type: "New Ledger",
                            param: { open: true },
                          });
                        }}
                        type="link"
                      >
                        New Ledger
                      </Button>
                    </>
                  </>
                )}
              />
            </Form.Item>
          </Form>
        </Spin>
      </Drawer>
      {openModel.type == "New Ledger" && (
        <AddLedger
          openDrawer={openModel.param?.open}
          setOpenDrawer={() =>
            setOpenModel({ type: "", param: { open: false } })
          }
          id=""
          placement={"left"}
          setAddLedgerResponse={setAddLedgerResponse}
        />
      )}
    </>
  );
};
export default AddCostCentreModel;
